<div class="bulk-history-detail-modal position-relative">
  <!-- Close button -->
  <button
    type="button"
    class="close position-absolute"
    style="top: 15px; right: 20px; z-index: 10;"
    aria-label="Close"
    (click)="onClose()"
  >
    <span aria-hidden="true">&times;</span>
  </button>

  <div class="container">
    <!-- Header -->
    <div class="action-bar">
      <div>
        <h3 class="mb-0">
          <ng-container *ngIf="job.isRevert">Reverted Price</ng-container>
          <ng-container *ngIf="!job.isRevert">History Logs Detail</ng-container>
          — {{ (job.startedAt || job.createdAt) | date:'MMM d, y' }}
        </h3>
        <p class="text-muted mb-0" style="font-size: 13px;">
          View the prices that were updated to Amazon.
        </p>
        <p class="mb-0 mt-1" style="font-size: 12px;">
          <ng-container *ngIf="job.isRevert && job.originalJobBatchId">
            Revert from
            <span class="modal-job-id modal-job-id--link" (click)="openRelatedJob(job.originalJobBatchId)">#{{ job.originalJobBatchId.slice(-8) }}</span>
          </ng-container>
        </p>
      </div>
    </div>

    <!-- Meta bar -->
    <div class="meta-bar">
      <div class="meta-item">
        <label class="meta-label">UPDATED</label>
        <span class="meta-value">{{ (job.startedAt || job.createdAt) | date:'MMM d, y · h:mm a' }}</span>
        <span class="meta-sub text-muted">{{ (job.startedAt || job.createdAt) | date:'EEEE' }}</span>
      </div>
      <div class="meta-item">
        <label class="meta-label">ACTOR</label>
        <span class="meta-value">{{ job.actorLabel }}</span>
      </div>
      <div class="meta-item">
        <label class="meta-label">SCOPE</label>
        <span class="meta-value">{{ job.totalCount }} SKU(s) affected</span>
        <div *ngIf="job.increasesCount != null" class="d-flex gap-2 mt-1">
          <span class="text-success small">▲ {{ job.increasesCount }} increases</span>
          <span class="text-danger small">▼ {{ job.decreasesCount }} decreases</span>
        </div>
      </div>
    </div>

    <!-- Job status banner -->
    <div *ngIf="job.status === 'IN_PROGRESS' && !job.isRevert" class="status-banner status-banner--progress">
      <div>
        <span class="spinner-border spinner-border-sm mr-2"></span>
        <ng-container *ngIf="!job.pendingRevert">
          <strong>Processing…</strong> Prices are being submitted to Amazon. You can <strong>schedule a revert now</strong> — prices will be restored automatically once all items are confirmed.
        </ng-container>
        <ng-container *ngIf="job.pendingRevert">
          <strong>Processing…</strong> Prices are being submitted to Amazon. A revert has been scheduled and will run automatically once all items are confirmed.
        </ng-container>
      </div>
    </div>
    <div *ngIf="job.status === 'IN_PROGRESS' && job.isRevert" class="status-banner status-banner--progress">
      <div>
        <span class="spinner-border spinner-border-sm mr-2"></span>
        <strong>Reverting…</strong>&nbsp;Prices are being restored to their original values on Amazon.
      </div>
    </div>
    <div *ngIf="job.status === 'PENDING'" class="status-banner status-banner--pending">
      <i class="feather icon-clock mr-2" style="flex-shrink:0;line-height:1;font-size:18px;"></i>
      <strong>Queued</strong> — This update is waiting to be processed.
    </div>
    <div *ngIf="job.status === 'FAILED'" class="status-banner status-banner--failed">
      <i class="feather icon-alert-triangle mr-2" style="flex-shrink:0;line-height:1;font-size:18px;"></i>
      <strong>Failed</strong> — This update encountered an error and could not complete.
    </div>
    <div *ngIf="job.pendingRevert" class="status-banner status-banner--pending">
      <i class="feather icon-clock mr-2" style="flex-shrink:0;line-height:1;font-size:18px;"></i>
      <strong>Revert Scheduled</strong> — Will trigger automatically once this update completes.
    </div>
    <div *ngIf="isBeingReverted" class="status-banner status-banner--progress">
      <span class="spinner-border spinner-border-sm mr-2"></span>
      <strong>Reverting…</strong>&nbsp;A revert job is currently restoring prices for this update.
      <ng-container *ngIf="revertJobBatchId">&nbsp;(job <span class="ml-2 modal-job-id modal-job-id--link" (click)="openRelatedJob(revertJobBatchId)">#{{ revertJobBatchId.slice(-8) }}</span>)</ng-container>
    </div>
    <div *ngIf="isReverted" class="status-banner status-banner--success">
      <i class="feather icon-check-circle mr-2" style="flex-shrink:0;line-height:1;font-size:18px;"></i>
      <strong>Reverted </strong><span> &mdash; </span> Prices have been restored to their previous values.
      <ng-container *ngIf="revertJobBatchId">&nbsp;See revert job <span class="ml-2 modal-job-id modal-job-id--link" (click)="openRelatedJob(revertJobBatchId)">#{{ revertJobBatchId.slice(-8) }}</span>.</ng-container>
    </div>

    <!-- Filters -->
    <div class="d-flex align-items-center mb-3 gap-3">
      <!-- Search input -->
      <div class="search-container flex-grow-1 m-0">
        <div class="search-input-wrapper">
          <i class="feather icon-search search-icon"></i>
          <input
            type="text"
            class="form-control search-input"
            placeholder="Search by SKU, ASIN..."
            [(ngModel)]="detailSearch"
            [disabled]="isLoading"
            (input)="onDetailSearchChange($event.target.value)"
          />
          <button
            *ngIf="detailSearch"
            class="clear-search-btn"
            (click)="clearSearch()"
            [disabled]="isLoading"
            title="Clear search"
          >
            <i class="feather icon-x"></i>
          </button>
        </div>
      </div>

      <!-- Status dropdown -->
      <div class="status-filter-wrapper flex-shrink-0">
        <kendo-dropdownlist
          [data]="statusOptions"
          textField="text"
          valueField="value"
          [valuePrimitive]="true"
          [(ngModel)]="selectedStatus"
          (valueChange)="onStatusChange($event)"
          [disabled]="isLoading"
          class="status-dropdown"
        >
        </kendo-dropdownlist>
      </div>
    </div>

    <!-- Grid -->
    <kendo-grid
      class="bulk-history-detail-table"
      [data]="{data: snapshots, total: total}"
      [loading]="isLoading"
      [height]="520"
      [pageable]="true"
      [pageSize]="pageSize"
      [skip]="skip"
      (pageChange)="pageChange($event)"
    >
      <!-- Column 1: SKU / ASIN -->
      <kendo-grid-column
        title="SKU / ASIN"
        [width]="200"
        [headerClass]="'col-header-sku text-center'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="sku-cell-content">
            <a
              [href]="getSkuLink(dataItem.entitySnapshot?.asin)"
              target="_blank"
              rel="noopener noreferrer"
              class="sku-link"
            >{{ dataItem.entitySnapshot?.sku || '—' }}</a>
            <span class="asin-tag">{{ dataItem.entitySnapshot?.asin || '—' }}</span>
          </div>
        </ng-template>
      </kendo-grid-column>

      <!-- Column 2: Previous Price -->
      <kendo-grid-column
        title="Previous Price"
        [headerClass]="'col-header-amazon text-center'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="price-detail-cell">
            <div class="price-field-row">
              <span class="price-field-label">Your Price</span>
              <span class="price-field-value">{{ dataItem.priceBefore?.inboundPrice | currency:'USD':'$':'1.2-2' }}</span>
            </div>
            <div class="price-field-row">
              <span class="price-field-label">Sale Price</span>
              <span class="price-field-value">{{ dataItem.priceBefore.salePrice == null ? 'N/A' : dataItem.priceBefore.salePrice | currency:'USD':'$':'1.2-2' }}</span>
            </div>
            <div class="price-field-row">
              <span class="price-field-label">Min</span>
              <span class="price-field-value">{{ dataItem.priceBefore.minPrice == null ? 'N/A' : dataItem.priceBefore.minPrice | currency:'USD':'$':'1.2-2' }}</span>
            </div>
            <div class="price-field-row">
              <span class="price-field-label">Max</span>
              <span class="price-field-value">{{ dataItem.priceBefore.maxPrice == null ? 'N/A' : dataItem.priceBefore.maxPrice | currency:'USD':'$':'1.2-2' }}</span>
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>

      <!-- Column 3: Changed Price -->
      <kendo-grid-column
        title="Changed Price"
        [headerClass]="'col-header-optimizer text-center'"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="dataItem.priceAfter; else pendingOrFailedTpl">
            <div class="price-detail-cell">
              <div class="price-field-row">
                <span class="price-field-label">Your Price</span>
                <span
                  class="price-field-value"
                  [ngClass]="{
                    'text-new-inc': dataItem.priceAfter.inboundPrice > (dataItem.priceBefore?.inboundPrice || 0),
                    'text-new-dec': dataItem.priceAfter.inboundPrice < (dataItem.priceBefore?.inboundPrice || 0)
                  }"
                >
                  {{ dataItem.priceAfter.inboundPrice | currency:'USD':'$':'1.2-2' }}
                  <span
                    *ngIf="getTrendPercent(dataItem) !== null && getTrendPercent(dataItem) !== 0"
                    class="trend-badge ml-1"
                    [ngClass]="{
                      'trend-badge--inc': (getTrendPercent(dataItem) || 0) > 0,
                      'trend-badge--dec': (getTrendPercent(dataItem) || 0) < 0
                    }"
                  >
                    {{ (getTrendPercent(dataItem) || 0) > 0 ? '▲' : '▼' }}
                    {{ (getTrendPercent(dataItem) || 0) | number:'1.1-1' }}%
                  </span>
                </span>
              </div>
              <div class="price-field-row">
                <span class="price-field-label">Sale Price</span>
                <span
                  class="price-field-value"
                  [ngClass]="{
                    'text-new-inc': dataItem.priceAfter.salePrice > (dataItem.priceBefore?.salePrice || 0),
                    'text-new-dec': dataItem.priceAfter.salePrice < (dataItem.priceBefore?.salePrice || 0)
                  }"
                >{{ dataItem.priceAfter.salePrice == null ? 'N/A' : dataItem.priceAfter.salePrice | currency:'USD':'$':'1.2-2' }}</span>
              </div>
              <div class="price-field-row">
                <span class="price-field-label">Min</span>
                <span class="price-field-value">{{ dataItem.priceAfter.minPrice == null ? 'N/A' : (dataItem.priceAfter.minPrice | currency:'USD':'$':'1.2-2') }}</span>
              </div>
              <div class="price-field-row">
                <span class="price-field-label">Max</span>
                <span class="price-field-value">{{ dataItem.priceAfter.maxPrice == null ? 'N/A' : (dataItem.priceAfter.maxPrice | currency:'USD':'$':'1.2-2') }}</span>
              </div>
            </div>
          </ng-container>

          <ng-template #pendingOrFailedTpl>
            <div class="price-detail-cell">
              <!-- Show requested price with trend logic -->
              <div class="price-field-row">
                <span class="price-field-label">Your Price</span>
                <span
                  class="price-field-value"
                  [ngClass]="{
                    'text-new-inc': dataItem.priceRequested?.inboundPrice > (dataItem.priceBefore?.inboundPrice || 0),
                    'text-new-dec': dataItem.priceRequested?.inboundPrice < (dataItem.priceBefore?.inboundPrice || 0)
                  }"
                >
                  {{ dataItem.priceRequested?.inboundPrice == null ? 'N/A' : (dataItem.priceRequested.inboundPrice | currency:'USD':'$':'1.2-2') }}
                  <span
                    *ngIf="getTrendPercent(dataItem) !== null && getTrendPercent(dataItem) !== 0"
                    class="trend-badge ml-1"
                    [ngClass]="{
                      'trend-badge--inc': (getTrendPercent(dataItem) || 0) > 0,
                      'trend-badge--dec': (getTrendPercent(dataItem) || 0) < 0
                    }"
                  >
                    {{ (getTrendPercent(dataItem) || 0) > 0 ? '▲' : '▼' }}
                    {{ (getTrendPercent(dataItem) || 0) | number:'1.1-1' }}%
                  </span>
                </span>
              </div>

              <div class="price-field-row">
                <span class="price-field-label">Sale Price</span>
                <span class="price-field-value">{{ dataItem.priceRequested?.salePrice == null ? 'N/A' : dataItem.priceRequested.salePrice | currency:'USD':'$':'1.2-2' }}</span>
              </div>

              <!-- Min Price — falls back to priceBefore when no custom min was set -->
              <div class="price-field-row">
                <span class="price-field-label">Min</span>
                <span class="price-field-value">
                  {{ getEffectiveMin(dataItem) == null ? 'N/A' : (getEffectiveMin(dataItem) | currency:'USD':'$':'1.2-2') }}
                </span>
              </div>

              <!-- Max Price — falls back to priceBefore when no custom max was set -->
              <div class="price-field-row">
                <span class="price-field-label">Max</span>
                <span class="price-field-value">
                  {{ getEffectiveMax(dataItem) == null ? 'N/A' : (getEffectiveMax(dataItem) | currency:'USD':'$':'1.2-2') }}
                </span>
              </div>

              <ng-container *ngIf="dataItem.outcome === 'FAILED'; else pendingBadgeTpl">
                <span
                  class="badge badge-failed mt-1"
                  [ngbTooltip]="dataItem.failureReason || 'Unknown error'"
                  placement="top"
                  container="body"
                >
                  <i class="feather icon-alert-circle mr-1"></i>Failed
                </span>
              </ng-container>
              <ng-template #pendingBadgeTpl>
                <span class="badge badge-pending mt-1">Pending Amazon</span>
              </ng-template>
            </div>
          </ng-template>
        </ng-template>
      </kendo-grid-column>

      <ng-template kendoGridNoRecordsTemplate>
        <div *ngIf="!isLoading" class="h-full py-4 text-center text-muted">
          No items found for this update.
        </div>
      </ng-template>

      <ng-template
        kendoPagerTemplate
        let-totalPages="totalPages"
        let-currentPage="currentPage"
      >
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
        <kendo-pager-page-sizes [pageSizes]="[10, 25, 50]"></kendo-pager-page-sizes>
        <div class="k-pager-info k-label">
          {{ total | number }} items
        </div>
      </ng-template>
    </kendo-grid>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="actions">
      <button class="btn cancel" (click)="onClose()">Cancel</button>
      <button
        *ngIf="canRevert()"
        type="button"
        class="btn revert-btn"
        [disabled]="isReverting || isLoading || job.pendingRevert"
        (click)="onRevert()"
      >
        <span *ngIf="isReverting" class="spinner-border spinner-border-sm mr-1"></span>
        <i *ngIf="!isReverting" class="feather icon-rotate-ccw mr-1"></i>
        {{ getRevertButtonLabel() }}
      </button>
    </div>
  </div>
</div>
